import { inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivateFn,
	CanMatchFn,
	Router,
	RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ModalService } from '../../services/modal.service';
import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandlerFn,
	HttpInterceptorFn,
	HttpRequest,
} from '@angular/common/http';
import { catchError, EMPTY, map, Observable, of, throwError } from 'rxjs';
import { LocalStorageService } from '../../services/localstorageService.service';
import { UserService } from '../../services/user.service';

export const authGuard: CanActivateFn | CanMatchFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	const localStorageService = inject(LocalStorageService);
	const router = inject(Router);
	const modalService = inject(ModalService);
	const userService = inject(UserService);
	const authService = inject(AuthService);

	const token = localStorageService.getToken();
	const rememberMe = localStorageService.getRememberMe();

	const navigationType = performance.getEntriesByType(
		'navigation'
	)[0] as PerformanceNavigationTiming;
    const justLoggedOut = sessionStorage.getItem('justLoggedOut') === 'true';

   
	if (navigationType?.type === 'reload' && !justLoggedOut) {
		return of(true);
	}

	if (rememberMe !== null && rememberMe !== 'false' && !token) {
		return authService.autoLogin().pipe(
			map((isLogged) => {
				if (isLogged) {
					return true;
				} else {
					modalService.openModal('authModal');
					router.navigate(['/', 'home']);
					return false;
				}
			})
		);
	}

	// Se c'è un token, verifica che l'utente sia loggato
	if (token) {
		const user = userService.userLogged();

		// Se il token è valido e l'utente è presente, consenti l'accesso
		if (user) {
			return of(true);
		}

		// Se c'è un token ma non un utente, significa che è necessario fare l'auto-login
		return authService.autoLogin().pipe(
			map((isLogged) => {
				if (isLogged) {
					return true;
				} else {
					// Se il login automatico fallisce, mostra il modal e reindirizza
					modalService.openModal('authModal');
					router.navigate(['/', 'home']);
					return false;
				}
			})
		);
	}

	// Se non c'è un token, non consentire l'accesso
	modalService.openModal('authModal');
	router.navigate(['/', 'home']);
	return of(false);
};
